<app-loading></app-loading>

<h3 class="ids-pt-8">procuradores</h3>

<section [formGroup]="procuratorRepresentationForm">
  <p class="ids-form ids-pt-2 ids-pv-4">os vendedores serão representados por procuração?</p>
  <ids-form-selection-group inline>
    <ids-form-selection class="ids-pt-2">
      <input
        type="radio"
        [value]="true"
        (change)="procuratorRadioChange(true)"
        name="useAttorneys"
        formControlName="useAttorneys"
        idsRadioButton
      />
      <label class="ids-ml-3">sim</label>
    </ids-form-selection>
    <ids-form-selection class="ids-pt-2">
      <input
        class="ids-ml-3"
        type="radio"
        (change)="procuratorRadioChange(false)"
        [value]="false"
        name="useAttorneys"
        formControlName="useAttorneys"
        idsRadioButton
      />
      <label class="ids-ml-3">não</label>
    </ids-form-selection>
  </ids-form-selection-group>
</section>

<form
  [formGroup]="procuratorForm"
  *ngIf="this.procuratorRepresentationForm?.value?.useAttorneys"
  autocomplete="off"
>
  <section formArrayName="procurators">
    <section *ngFor="let procurator of procuratorArray.controls; let i = index">
      <section [formGroupName]="i" style="display: flex; flex-direction: column">
        <section class="ids-row ids-pt-8" style="display: flex; justify-content: space-between">
          <div class="ids-col-6">
            <h3 class="ids-text-section-02 ids-col-6">procurador {{ i + 1 }}</h3>
          </div>
          <div class="ids-col-6">
            <button
              *ngIf="i >= 1"
              #originModalRemoveProcurator
              idsActionButton
              idsOverlayOrigin
              class="ids-col-6"
              (click)="setIsOpenModalRemoveProcurator(i)"
            >
              <ids-icon>excluir_outline</ids-icon>
              excluir
            </button>
          </div>
        </section>

        <p class="ids-form ids-pt-2 ids-pv-4">qual o tipo de procurador?</p>
        <ids-form-selection-group inline>
          <ids-form-selection class="ids-pt-2">
            <input
              type="radio"
              value="fisica"
              [name]="'type'+i"
              [formControlName]="'type'+i"
              (click)="setPessoaCPFValidator(i)"
              idsRadioButton
            />
            <label class="ids-ml-3">pessoa física</label>
          </ids-form-selection>
          <ids-form-selection class="ids-pt-2">
            <input
              class="ids-ml-3"
              type="radio"
              value="juridica"
              [name]="'type'+i"
              [formControlName]="'type'+i"
              (click)="setCNPJValidator(i)"
              idsRadioButton
            />
            <label class="ids-ml-3">pessoa jurídica</label>
          </ids-form-selection>
        </ids-form-selection-group>

        <section
          class="ids-row ids-pt-8"
          *ngIf="this.procuratorForm?.value?.procurators[i]?.['type'+i]  !== '' "
        >
          <ids-form-field
            class="ids-col-6"
            [label]="procuratorForm?.value?.procurators[i]?.['type' + i] == 'fisica' ? 'nome completo' : 'razão social'"
             [errorMessage]="getTextFieldError(i, 'name', procuratorForm?.value?.procurators[i]?.['type' + i] == 'fisica' ? 'o nome completo' : 'a razão social')"
          >
            <input idsInput formControlName="name"/>
          </ids-form-field>

          <ids-form-field class="ids-col-6"
                          [label]="procuratorForm?.value?.procurators[i]?.['type' + i] == 'fisica' ? 'CPF' : 'CNPJ'"
                          [errorMessage]="getErrorInvalid('CPF ou CNPJ')">
            <input
              idsInput
              appUpperCaseInput
              [idsMask]="maskCpfCnpj"
              formControlName="documentNumber"
              [maxlength]="procuratorForm?.value?.procurators[i]?.['type'+i]  == 'fisica' ? 14 : 20 "
            />
          </ids-form-field>
        </section>

        <section
          class="ids-row ids-pt-2"
          *ngIf="this.procuratorForm?.value?.procurators[i]?.['type'+i]  !== '' "
        >
          <ids-form-field class="ids-col-6" label="E-mail" [errorMessage]="getEmailFieldError(i, 'email', 'o e-mail')">
            <input idsInput formControlName="email" (blur)="normalizeEmail('email')" />
          </ids-form-field>

          <ids-form-field class="ids-col-6" label="Celular ou telefone" [errorMessage]="getTextFieldError(i, 'phone','o celular ou telefone')">
            <input idsInput [idsMask]="phoneMask" formControlName="phone"/>
          </ids-form-field>
        </section>
      </section>
    </section>
  </section>

  <button
    class="ids-pt-8 ids-pb-8"
    idsActionButton
    type="button"
    (click)="addProcurator()"
    *ngIf="this.procuratorArray.length < 4"
  >
    <ids-icon>add_circle_base</ids-icon>
    incluir mais um procurador
  </button>
</form>

<ids-modal
  [(open)]="isOpenModalRemoveProcurator"
  width="684px"
>
  <ids-modal-header noDivider></ids-modal-header>
  <p class="ids-section-title -small ids-mx-4">deseja excluir este procurador?</p>

  <div
    class="ids-card ids-m-4 ids-p-4"
    *ngIf="currentItemSelected?.name || currentItemSelected?.documentNumber"
  >
    <section class="ids-row">
      <section class="ids-col-6">
        <section>
          <h3
            class="ids-text-label-small ids-pv-2">{{ currentItemSelected.documentNumber.length > 11 ? 'razão social' : 'nome completo' }}</h3>
          <p class="ids-text-section-01 ids-pb-4">
            {{ currentItemSelected?.name || '-' }}
          </p>
        </section>
      </section>

      <section class="ids-col-6">
        <section>
          <h3
            class="ids-text-label-small ids-pv-2">{{ currentItemSelected.documentNumber.length > 11 ? 'CNPJ ' : 'CPF' }}</h3>
          <p class="ids-text-section-01 ids-pb-4">
            {{ currentItemSelected?.documentNumber | idsMask: maskCpfCnpj || '-' }}
          </p>
        </section>
      </section>
    </section>
  </div>

  <ids-modal-footer>
    <button idsMainButton variant="secondary" (click)="closeModal()">não excluir</button>

    <button idsMainButton (click)="modalConfirmRemove()">sim, quero excluir</button>
  </ids-modal-footer>
</ids-modal>
